import { DialogService, GridAction } from '@eforall/dashboard';
import { ContactEngagement, DialogMode } from '@interfaces';
import { EngagementEditorDialog, EngagementEditorDialogData, EngagementViewerDialog } from '../../../../widget';
import { AccApplicationDialogDataService } from '../../acc-application-dialog-data.service';

export function getActions(pageService: AccApplicationDialogDataService, dialogService: DialogService) {

	const actions: GridAction<ContactEngagement>[] = [
		{
			iconClass: 'fa-regular fa-message-arrow-up-right',
			label: 'View Engagement',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(EngagementViewerDialog, { data: { engagementId: rows[0]!.id } }, 700, 700);
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Edit Engagement',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const dialogData: EngagementEditorDialogData = {
					mode: DialogMode.EDIT,
					engagementId: rows[0]!.id,
				};
				const dialogAction = await dialogService.showCustom(EngagementEditorDialog, { data: dialogData }, 650, 800);

				// If save succeeds, callbackResult contains the updated engagementId; otherwise, it is undefined.
				if (dialogAction?.callbackResult) {
					await pageService.reloadData();
				}
			}
		},
	];

	return actions;
}